import React from 'react';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    number: 'Bonus 1',
    title: 'Le Carnet des Transitions Fluides',
    desc: 'Maîtrisez l\'art de connecter les exercices pour un "Flow" parfait en studio.',
    image: 'https://cdn.magicpatterns.com/uploads/wurLTJ9fcs5HmeA3SXXRck/513d5de2-6b65-43d5-a899-599ceb31df80-mockup.webp'
  }, {
    number: 'Bonus 2',
    title: 'L\'Aide-Mémoire "Props & Accessoires"',
    desc: 'Référence visuelle complète pour utiliser balles, anneaux et accessoires avec confiance.',
    image: 'https://cdn.magicpatterns.com/uploads/9diMVSCrxM9W3Nc2ewaEAc/1d351ae5-006a-4a1e-82ca-6f7bd2561aab-mockup.webp'
  }, {
    number: 'Bonus 3',
    title: 'Le Guide Marketing pour Studios FR',
    desc: 'Stratégies concrètes pour faire connaître votre studio et fidéliser vos élèves.',
    image: 'https://cdn.magicpatterns.com/uploads/wgWjczr6aywTL6Zj3mAF7V/5f74c72c-dd1e-40af-8b5d-f5e600e42a6b-mockup.webp'
  }, {
    number: 'Bonus 4',
    title: "Checklist de l'Instructeur d'Élite",
    desc: 'Les habitudes et standards qui distinguent les meilleurs instructeurs de la profession.',
    image: 'https://cdn.magicpatterns.com/uploads/tt9QapCEhf9JY7HCD6WYgw/a760b793-b208-40af-9b1e-c3ae2f81d2e6-mockup.webp'
  }, {
    number: 'Bonus 5',
    title: 'Le Lexique Français-Anglais du Pilates',
    desc: 'Donnez vos cours en anglais aux expatriés. Tous les termes techniques traduits.',
    image: 'https://cdn.magicpatterns.com/uploads/cz8vAifjs5CazN9R8Dxcm5/f99446f1-57c3-4126-92b4-30edcc8c544e-mockup.webp'
  }];
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden pt-[010px] pb-[010px]" data-id="element-25">
      <div className="absolute top-20 right-0 w-96 h-96 bg-pilates-sage/15 rounded-full blur-3xl pointer-events-none" data-id="element-26"></div>
      <div className="absolute bottom-20 left-0 w-96 h-96 bg-pilates-lavender/15 rounded-full blur-3xl pointer-events-none" data-id="element-27"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-28">
        <div className="text-center mb-14" data-id="element-29">
          <div className="bg-pilates-rose/15 text-pilates-rose-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em] flex items-center gap-2 w-fit mx-auto" data-id="element-30">
            <Gift className="w-4 h-4" data-id="element-31" /> 5 Bonus Inclus
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-4 tracking-tight" data-id="element-32">
            Et en plus, recevez{' '}
            <span className="italic text-pilates-rose" data-id="element-33">5 bonus de luxe</span>
          </h2>
          <p className="text-pilates-slate text-base sm:text-lg max-w-2xl mx-auto" data-id="element-34">
            Des ressources exclusives qui transformeront votre quotidien
            d'instructeur — incluses gratuitement avec votre pack.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-35">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl p-6 shadow-md border border-pilates-sage/15 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col" data-id="element-36">
              <div className="relative mb-5 overflow-hidden rounded-xl bg-gradient-to-br from-pilates-cream to-pilates-soft aspect-square" data-id="element-37">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-38" />
                <div className="absolute top-3 left-3 bg-pilates-rose text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-md" data-id="element-39">
                  {bonus.number}
                </div>
                <div className="absolute top-3 right-3 bg-pilates-sage-dark text-white text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider shadow-md" data-id="element-40">
                  🎁 Gratuit
                </div>
              </div>
              <h3 className="font-display font-semibold text-pilates-dark text-lg leading-tight mb-2" data-id="element-41">
                {bonus.title}
              </h3>
              <p className="text-pilates-slate text-sm leading-relaxed" data-id="element-42">
                {bonus.desc}
              </p>
            </div>)}

          {/* Decorative card showing total value */}
          <div className="bg-gradient-to-br from-pilates-sage-dark to-pilates-dark rounded-2xl p-6 shadow-md flex flex-col items-center justify-center text-center text-white" data-id="element-43">
            <Gift className="w-12 h-12 text-pilates-cream mb-3" data-id="element-44" />
            <p className="text-white/80 text-sm uppercase tracking-wider mb-2" data-id="element-45">
              Tout inclus dans
            </p>
            <p className="font-display text-3xl font-semibold text-pilates-cream mb-2" data-id="element-46">
              le Pack 6 en 1
            </p>
            <p className="text-white/75 text-sm leading-relaxed" data-id="element-47">
              Les 5 bonus sont offerts gratuitement avec votre achat
              aujourd'hui.
            </p>
          </div>
        </div>
      </div>
    </section>;
}